import styled from "styled-components";

/**
 * Dashboard styled components
 *
 * This module contains all styled components used in the Dashboard feature,
 * organized for layout, cards, statistics, and charts.
 */

export const DashboardContainer = styled.div`
  padding: 20px;
  max-width: 1400px;
  margin: 0 auto;
`;

export const DashboardGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(400px, 1fr));
  gap: 20px;
  margin-top: 20px;
`;

export const DashboardCard = styled.div`
  background: white;
  border-radius: 8px;
  padding: 20px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  border: 1px solid #e5e7eb;
`;

export const CardTitle = styled.h3`
  margin: 0 0 15px 0;
  font-size: 18px;
  font-weight: 600;
  color: #1f2937;
  border-bottom: 2px solid #e5e7eb;
  padding-bottom: 8px;
`;

export const StatRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 8px 0;
  border-bottom: 1px solid #f3f4f6;

  &:last-child {
    border-bottom: none;
  }
`;

export const StatLabel = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 14px;
  color: #4b5563;
`;

export const StatValue = styled.div`
  font-size: 16px;
  font-weight: 600;
  color: #1f2937;
`;

export const BigStat = styled.div`
  text-align: center;
  padding: 20px;
`;

export const BigStatValue = styled.div`
  font-size: 48px;
  font-weight: 700;
  color: #2563eb;
`;

export const BigStatLabel = styled.div`
  font-size: 14px;
  color: #6b7280;
  margin-top: 8px;
  text-transform: uppercase;
  letter-spacing: 1px;
`;

export const ChartContainer = styled.div`
  height: 300px;
  margin-top: 10px;
`;

export const ResourceGroup = styled.div`
  margin-bottom: 15px;

  &:last-child {
    margin-bottom: 0;
  }
`;

export const GroupTitle = styled.div`
  font-size: 12px;
  font-weight: 600;
  color: #6b7280;
  margin-bottom: 8px;
  text-transform: uppercase;
  letter-spacing: 0.5px;
`;
